import { QuillyEditor } from "vue-quilly";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("QuillyEditor", QuillyEditor);
});
